module.exports = __webpack_public_path__ + "img/map.82832573.svg";